import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import { ENV_ANDROID } from '../../const';
import { app, env } from '../../getNativeInfo';
import { prepareApi, uniCall } from '../../utils';
prepareApi(['bcz_system']);
/**
 * 修改主题
 */

export function changeTheme(_a) {
  var iconType = _a.iconType,
      navBGColor = _a.navBGColor,
      _b = _a.webBGColor,
      webBGColor = _b === void 0 ? '#FFFFFF' : _b;
  return new Promise(function (resolve) {
    // `#FFFFFF` => `FFFFFF`
    if (/^#/.test(navBGColor)) {
      navBGColor = navBGColor.slice(1);
    } // `#FFFFFF` => `FFFFFF`


    if (/^#/.test(webBGColor)) {
      webBGColor = webBGColor.slice(1);
    }

    var params = JSON.stringify({
      iconType: iconType,
      backgroundColor: navBGColor,
      webViewBackgroundColor: webBGColor
    });

    if (env === ENV_ANDROID && app === 'ireading') {
      window.bcz_system.changeTheme(navBGColor, iconType === 1 ? 'FFFFFF' : '000000');
      resolve();
      return;
    }

    uniCall({
      api: 'changeTheme',
      param: params
    });
    resolve();
  });
}
/**
 * 设置导航条主题
 * @deprecated Use `changeTheme` instead
 */

export var setNavigatorBarTheme = changeTheme;